import MediaManagerService from '../../services/MediaManagerService'
import MediaService from '../../services/MediaService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'
import PoiService from '../../services/PoiService'
import MenuItemsService from '../../services/MenuItemsService'
import MediaHelper from '../../helpers/MediaHelper'
import Enums from '../../helpers/Enums'
export const namespaced = true

const initialState = {
  media: [],
  selectedMediaItem: {},
  mediaTypes: [],
  currentMediaPageNumber: 1,
  mediaPageSize: 20,
  checkedMedia: []
}

export const state = { ...initialState }

export const mutations = {
  SET_MEDIA(state, recs) {
    state.media = recs
  },
  REMOVE_MEDIA_ITEM(state, mediaIds) {
    state.media = state.media.filter(m => !mediaIds.includes(m.id))
  },
  SET_SELECTED_MEDIA_ITEM(state, rec) {
    state.selectedMediaItem = rec
  },
  SET_MEDIA_TYPES(state, recs) {
    state.mediaTypes = recs
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  },
  SET_CURRENT_PAGE_NUMBER(state, data) {
    state.currentMediaPageNumber = data
  },
  RESET_PAGING(state) {
    state.currentMediaPageNumber = initialState.currentMediaPageNumber
    state.mediaPageSize = initialState.mediaPageSize
  },
  ADD_MEDIA(state, recs) {
    state.media = state.media.map(m => recs.find(r => r.id === m.id) || m) //update existing
    // add new recs
    recs.map(r => {
      if (!state.media.find(m => r.id === m.id)) {
        state.media.push(r)
      }
    })
  },
  SET_CHECKED_MEDIA(state, media) {
    state.checkedMedia = media
  },
  RESET_CHECKED_MEDIA(state) {
    state.checkedMedia = []
  }
}

export const actions = {
  fetchMedia: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    value = Object.assign({}, value, {
      pageNumber: context.state.currentMediaPageNumber,
      pageSize: context.state.mediaPageSize
    })
    let res = await MediaManagerService.getMedia(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    )

    if (res.data.length === context.state.mediaPageSize) {
      context.commit(
        'SET_CURRENT_PAGE_NUMBER',
        context.state.currentMediaPageNumber + 1
      )
    }

    context.commit('ADD_MEDIA', res.data)

    // else if (
    //   res.data.length > 0 &&
    //   res.data.length < context.state.mediaPageSize
    // ) {
    //   let mediaIds = context.state.media.map(m => m.id)
    //   let mediaToAdd = res.data.filter(m => {
    //     return !mediaIds.includes(m.id)
    //   })
    //   if (mediaToAdd.length > 0) {
    //     context.commit('ADD_MEDIA', mediaToAdd)
    //   } else {
    //     console.warn('End of list!')
    //   }
    // }

    //context.commit('SET_MEDIA', res.data)
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },
  fetchAllMedia: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    // value = Object.assign({}, value, {
    //   pageNumber: context.state.currentMediaPageNumber,
    //   pageSize: context.state.mediaPageSize
    // })
    let res = await MediaManagerService.getMedia(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    )

    // if (res.data.length === context.state.mediaPageSize) {
    //   context.commit(
    //     'SET_CURRENT_PAGE_NUMBER',
    //     context.state.currentMediaPageNumber + 1
    //   )
    // }

    context.commit('ADD_MEDIA', res.data)

    // else if (
    //   res.data.length > 0 &&
    //   res.data.length < context.state.mediaPageSize
    // ) {
    //   let mediaIds = context.state.media.map(m => m.id)
    //   let mediaToAdd = res.data.filter(m => {
    //     return !mediaIds.includes(m.id)
    //   })
    //   if (mediaToAdd.length > 0) {
    //     context.commit('ADD_MEDIA', mediaToAdd)
    //   } else {
    //     console.warn('End of list!')
    //   }
    // }

    //context.commit('SET_MEDIA', res.data)
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  // fetchAddMedia: async function(context, value) {
  //   context.commit('SET_LOADING_STATUS', 'loading', { root: true })
  //   value = Object.assign({}, value, {
  //     pageNumber: context.state.currentMediaPageNumber,
  //     pageSize: context.state.mediaPageSize
  //   })
  //   let res = await MediaManagerService.getMedia(
  //     context.rootGetters['ProjectStore/getSelectedProjectId'],
  //     value
  //   )
  //   context.commit('ADD_MEDIA', res.data)
  //   context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  //   return res
  // },

  linkMedia: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let res = await MediaManagerService.linkMedia(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    ).catch(e => {
      //context.commit('SET_SELECTED_MEDIA_ITEM', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  getMediaPois: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let res = await MediaManagerService.getMediaPois(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    ).catch(e => {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  deleteMediaRecord: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let res
    try {
      res = await MediaManagerService.deleteMediaRecord(
        context.rootGetters['ProjectStore/getSelectedProjectId'],
        value
      )
      context.commit(
        'SET_MEDIA',
        context.state.media.filter(m => m.id !== value)
      )
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  getTreeView: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let res = await MediaManagerService.getTreeView(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    ).catch(e => {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  setMediaLinks: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    value.projectId = parseInt(
      context.rootGetters['ProjectStore/getSelectedProjectId']
    )
    let res = await MediaManagerService.setMediaLinks(value).catch(e => {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return res
  },

  setSelectedMediaItem: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    let m = await MediaManagerService.getMediaById(value).catch(e => {
      //context.commit('SET_SELECTED_MEDIA_ITEM', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    context.commit('SET_SELECTED_MEDIA_ITEM', m.data)
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    return m
  },

  createMedia: async function(context, value) {
    return await MediaManagerService.createMedia(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    ).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
    })
  },
  updateMedia: async function(context, value) {
    let res = await MediaManagerService.updateMedia(
      context.rootGetters['ProjectStore/getSelectedProjectId'],
      value
    )
    // context.dispatch('fetchMedia')
    return res
  },
  deleteMedia: async function(context, value) {
    try {
      await MediaManagerService.deleteMedia(value)
      console.log('deleteMedia', value)
      context.commit('REMOVE_MEDIA_ITEM', value)
      context.commit('SET_SELECTED_MEDIA_ITEM', null)
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
  },

  uploadFiles: async function(context, value) {
    return await MediaService.upload(
      value.files,
      context.rootGetters['ProjectStore/getSelectedProjectId']
    ).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
    })
  },

  downloadFile: function(context, value) {
    return MediaService.getThumbnail(value)
  },

  fetchMediaTypes: async function(context, value) {
    return MediaManagerService.getMediaTypes(value).then(
      r => {
        context.commit('SET_MEDIA_TYPES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_MEDIA_TYPES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },

  getFile: function(context, value) {
    let targetContext = 'media'
    let parentId = ''
    let queryParams = ''
    //check if dzi file
    if (value.path.toLowerCase().indexOf('.dzi') !== -1) {
      queryParams = '?type=thumbnail'
    }
    console.log('MEDIA CONTEXT ', state.mediaContext)
    console.log(
      'project id ',
      context.rootGetters['ProjectStore/getSelectedProjectId']
    )
    switch (state.mediaContext) {
      case 'project':
        parentId = context.rootGetters['ProjectStore/getSelectedProjectId']
        targetContext = 'projects'
        break
      case 'poi':
        parentId = context.rootGetters['PoiStore/getSelectedPoiId']
        targetContext = 'pois'
        break
      case 'menu_item':
        parentId = context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
        targetContext = 'menu-items'
        break
      default:
        parentId = context.rootGetters['ProjectStore/getSelectedProjectId']
        targetContext = 'projects'
        break
    }
    return MediaService.getMediaFile(
      `${targetContext}/${parentId}/media-content/${
        value.id
      }/file${queryParams}`
    )
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  resetMedia: async function(context) {
    context.commit('SET_MEDIA', [])
  },
  resetPaging: function(context) {
    context.commit('RESET_PAGING')
  },
  setCheckedMedia: ({ commit }, media) => {
    commit('SET_CHECKED_MEDIA', media)
  },
  resetCheckedMedia: ({ commit }) => {
    commit('RESET_CHECKED_MEDIA')
  }
}

export const getters = {}
